document.addEventListener('DOMContentLoaded', function() {

  // Mobile menu toggle
  var menuToggles = document.querySelectorAll('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  menuToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  });

  // Mobile menu accordion submenus
  var accordions = document.querySelectorAll('[data-mobile-accordion]');
  accordions.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      btn.classList.toggle('is-expanded');
      var children = btn.nextElementSibling;
      if (children && children.hasAttribute('data-mobile-children')) {
        children.classList.toggle('is-open');
      }
    });
  });

  // Footer accordion (mobile only)
  var footerToggles = document.querySelectorAll('[data-footer-toggle]');
  var mobileBreakpoint = 768;

  footerToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      if (window.innerWidth > mobileBreakpoint) return;
      var column = toggle.closest('[data-footer-accordion]');
      if (column) {
        column.classList.toggle('is-open');
      }
    });
  });

  // Reset footer accordion on resize to desktop
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > mobileBreakpoint) {
        document.querySelectorAll('[data-footer-accordion]').forEach(function(col) {
          col.classList.remove('is-open');
        });
      }
    }, 150);
  });

  // Sticky add-to-cart bar visibility
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('.product-page__add-to-cart');

  if (stickyBar && mainAtc) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
        stickyBar.style.transition = 'transform 0.25s ease';
      });
    }, { threshold: 0, rootMargin: '0px 0px -56px 0px' });

    stickyObserver.observe(mainAtc);

    // Sticky bar button scrolls to form and submits
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var form = document.querySelector('.product-page form[action*="/cart/add"]');
        if (form) {
          mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function() { form.submit(); }, 400);
        }
      });
    }
  }

  // Close mobile menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // Prevent body scroll when mobile menu or cart drawer is open
  document.querySelectorAll('.mobile-menu__panel, .cart-drawer').forEach(function(panel) {
    panel.addEventListener('touchmove', function(e) {
      if (panel.scrollHeight <= panel.clientHeight) {
        e.preventDefault();
      }
    }, { passive: false });
  });

});
